import { createFileRoute } from "@tanstack/react-router";
import { buildPageHead } from "@/lib/seo";
import Hub from "@/pages/Hub";

export const Route = createFileRoute("/hub/")({
  head: () =>
    buildPageHead({
      title: "Hub: Topics Across the Blog, Guides & Metrics | Bigdelta",
      description:
        "Blog posts, guides and metric pages collected by topic — traffic, conversion, revenue, churn and the rest of the SaaS lifecycle.",
      path: "/hub",
    }),
  component: Hub,
});
